<header class="header-route">
  <img
    src="/assets/icons/arrow-left.svg"
    [alt]="'COMMONS.EXIT' | i18nextEager"
    (click)="handleGoBack()"
    class="arrow"
  />
  <img src="/assets/icons/logo.svg" class="element" [alt]="'COMMONS.ACCIONA_LOGO' | i18nextEager" />
  <div class="container-title element">
    <h5>green energy</h5>
    <span class="separator"></span>
    <span class="subtitle">{{ 'HOME.NEW_CONTRACT' | i18nextEager | uppercase }}</span>
  </div>
  <div class="space"></div>
  <div class="icon" [ngClass]="{ 'separator-icon': tabIndex !== 5, 'margin-right': tabIndex === 5 }">
    <img
      src="/assets/icons/delete.svg"
      [alt]="'HOME.CANCEL_CONTRACT' | i18nextEager"
      *ngIf="!haveIdDraft && tabIndex !== 5; else elseBlock"
    />
    <ng-template #elseBlock>
      <img
        src="/assets/icons/deleteRed.svg"
        [alt]="'HOME.CANCEL_CONTRACT' | i18nextEager"
        class="cursor-pointer"
        (click)="deleteContract()"
      />
    </ng-template>
  </div>
  <!-- <div *ngIf="tabIndex !== 5" class="separator-icon icon">
    <img
      src="/assets/icons/download_red.svg"
      [alt]="'COMMONS.DOWNLOAD' | i18nextEager"
      class="cursor-pointer"
      (click)="handleDownload()"
    />
  </div> -->
  <div *ngIf="tabIndex !== 5" class="separator-icon icon">
    <img *ngIf="!canSave" src="/assets/icons/save_gray.svg" [alt]="'COMMONS.SAVE' | i18nextEager" />
    <img
      *ngIf="canSave"
      src="/assets/icons/save_red.svg"
      [alt]="'COMMONS.SAVE' | i18nextEager"
      class="cursor-pointer"
      (click)="handleSave()"
    />
  </div>
  <div *ngIf="tabIndex !== 5" class="icon">
    <img
      [src]="'/assets/icons/progress-' + progress + '.svg'"
      [alt]="'COMMONS.PROGRESS' | i18nextEager"
      (click)="handleOpenProgress()"
      [ngClass]="{ 'cursor-pointer': tabIndex !== 1 }"
    />
  </div>
  <button *ngIf="tabIndex !== 5" (click)="handleGoNext()" [disabled]="!canGoNext" class="margin-right">
    {{ 'COMMONS.NEXT' | i18nextEager }}
  </button>
</header>
<div class="new-contract-pymes-multipoint__container">
  <div class="new-contract-pymes-multipoint__loader" *ngIf="isLoading">
    <app-loading [onlyIcon]="true"></app-loading>
    <p>{{ 'COMMONS.LOADING' | i18nextEager }}</p>
    <p *ngIf="showProgressInstallations">
      {{ 'NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATIONS' | i18nextEager }}: {{ progressInstallations }} /
      {{ installationsData.length }}
    </p>
  </div>
  <mat-tab-group
    [selectedIndex]="tabIndex - 1"
    (selectedTabChange)="tabChange($event)"
    class="new-contract-pymes-multipoint__stepper"
  >
    <mat-tab [aria-labelledby]="tabIndex >= 1 ? 'active' : null" [disabled]="tabIndex === 1 || tabIndex === 5">
      <app-multipoint-business-name-pymes
        *ngIf="tabIndex === 1 && chargedData"
        (changeLoader)="changeLoader($event)"
        (data)="handleDataBusiness($event)"
      ></app-multipoint-business-name-pymes>
    </mat-tab>
    <mat-tab [aria-labelledby]="tabIndex >= 2 ? 'active' : null" [disabled]="tabIndex <= 2 || tabIndex === 5">
      <app-multipoint-type-charge
        *ngIf="tabIndex === 2 && chargedData"
        (changeLoader)="changeLoader($event)"
        (data)="handleDataPreInstallation($event)"
      ></app-multipoint-type-charge>
    </mat-tab>
    <mat-tab [aria-labelledby]="tabIndex >= 3 ? 'active' : null" [disabled]="tabIndex <= 3 || tabIndex === 5">
      <app-multipoint-installation-pymes
        *ngIf="tabIndex === 3 && chargedData"
        [overWriteInstallations]="overWriteInstallations"
        (changeLoader)="changeLoader($event)"
        (data)="handleDataInstallation($event)"
        (saveInstallations)="handleSave(null, null, false)"
      ></app-multipoint-installation-pymes>
    </mat-tab>
    <mat-tab [aria-labelledby]="tabIndex >= 4 ? 'active' : null" [disabled]="tabIndex <= 4 || tabIndex === 5">
      <app-multipoint-signer-contract
        *ngIf="tabIndex === 4 && chargedData"
        (changeLoader)="changeLoader($event)"
        (data)="handleDataSigner($event)"
        (installationData)="handleDataInstallation($event)"
      ></app-multipoint-signer-contract>
    </mat-tab>
    <mat-tab [aria-labelledby]="tabIndex >= 5 ? 'active' : null" [disabled]="true">
      <app-contract-signing
        *ngIf="tabIndex === 5 && chargedData"
        [multipoint]="true"
        (isLoading)="changeLoader($event)"
      ></app-contract-signing>
    </mat-tab>
  </mat-tab-group>
</div>
